import React, { Component } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory from 'react-bootstrap-table2-editor';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import Alert from 'react-bootstrap/Alert';
import Tooltip from '@material-ui/core/Tooltip';

import ReactToPrint, { PrintContextConsumer } from "react-to-print";

import Spinner from '../../../../layout/Spinner/snipper.component';
import './table-calculator.style.css'

// const MyExportCSV = (props) => {
//     const handleClick = () => {
//         props.onExport();
//     };
//     return (
//         <div className="container-export-button ">
//             <Tooltip title="Export to CSV" placement="right" arrow >
//                 {/* <Button>Arrow</Button> */}
//                 <button className="btn-export" onClick={handleClick}><i className="fas fa-file-excel-o"></i></button>
//             </Tooltip>
//         </div>
//     );
// };

class TableCalculator extends Component {
    constructor(props) {
        super();
    }

    validator = (newValue, row, column) => {
        if (isNaN(newValue)) {
            return {
                valid: false,
                message: 'Value should be numeric'
            };
        }
        if (newValue < 0) {
            return {
                valid: false,
                message: 'Value should bigger than 0'
            };
        }
        return true;
    }

    getEditValue = (dmaID, dataField, value) => {
        this.props.sendEditValueToParent(dmaID, dataField, value);
    }

    colHeaderFormatUnit = (column, colIndex) => {
        return <span>{column.text} (m<sup>3</sup>/day)</span>
    }

    colHeaderFormatUnitM3 = (column, colIndex) => {
        return <span>{column.text} (m<sup>3</sup>/day)</span>
    }

    render() {
        if (this.props.loading) {
            return <Spinner />
        }

        // const { ExportCSVButton } = CSVExport;

        const columns = [{
            dataField: 'dmaid',
            text: 'DMA ID ',
            sort: true,
            style: {
                width: '90px'
            }
        }, {
            dataField: 'total_connections',
            text: 'Total Number of Connections (nos)',
            validator: this.validator
        },
        {
            dataField: 'total_length',
            text: 'Total Length of Mains (km)',
            validator: this.validator
        },
        {
            dataField: 'average_pressure',
            text: 'Average Pressure (m)',
            validator: this.validator
        },
        {
            dataField: 'water_supplied',
            text: 'Water Supplied To This System',
            headerFormatter: this.colHeaderFormatUnitM3,
            validator: this.validator
        },
        {
            dataField: 'bill_meter_consump',
            text: 'Billed Metered Consumption',
            headerFormatter: this.colHeaderFormatUnitM3,
            validator: this.validator
        },
        {
            dataField: 'bill_unmeter_consump',
            text: 'Billed Unmetered Consumption (Average Reading)',
            headerFormatter: this.colHeaderFormatUnit,
            validator: this.validator
        },
        {
            dataField: 'per_unbill_auth_cons',
            text: 'Unbilled Authorised Consumption (%)',
            validator: this.validator
        },
        {
            dataField: 'per_unauth_cons',
            text: 'Unauthorised Consumption (Illegal) (%)',
            validator: this.validator
        },
        {
            dataField: 'per_meter_inaccura',
            text: 'Customer Metering Inaccuracies (%)',
            validator: this.validator
        },];

        const defaultSorted = [{
            dataField: 'dmaid',
            order: 'asc'
        }];
        const products = this.props.data;

        if (Array.isArray(products) && products.length) {
            return (
                <div>
                    {/* <ToolkitProvider
                        keyField='dmaid'
                        bootstrap4
                        data={products}
                        columns={columns}
                        wrapperClasses="table-responsive"
                        defaultSorted={defaultSorted}
                        cellEdit={cellEditFactory({
                            mode: 'dbclick',
                            blurToSave: true,
                            afterSaveCell: (oldValue, newValue, row, column) => { this.getEditValue(row['dmaid'], column['dataField'], newValue); }
                        })}
                        version='4'
                        exportCSV
                    >
                        {
                            props => (
                                <div>
                                    <ExportCSVButton {...props.csvProps}>Export CSV!!</ExportCSVButton>
                                    <MyExportCSV {...props.csvProps} />
                                    <hr />
                                    <BootstrapTable {...props.baseProps} />
                                </div>
                            )
                        }
                    </ToolkitProvider> */}


                    {/* property wrapperClass is the default prop of component, I use table-responsive from CSS of Bootstrap 4 */}
                    <BootstrapTable keyField='dmaid'
                        bootstrap4
                        data={products}
                        columns={columns}
                        wrapperClasses="table-responsive"
                        defaultSorted={defaultSorted}
                        cellEdit={cellEditFactory({
                            mode: 'dbclick',
                            blurToSave: true,
                            afterSaveCell: (oldValue, newValue, row, column) => { this.getEditValue(row['dmaid'], column['dataField'], newValue); }
                        })}
                        version='4' />

                </div>
            )
        }
        else {
            return (
                <div>
                    {this.props.hasData ? (
                        <Alert variant='info'>
                            Please click fill to fill your data!
                        </Alert>
                    ) : (
                            <Alert variant='danger'>
                                No data found!
                            </Alert>)}
                </div>
            )
        }


    }
}

class ExportPDFCalculateTable extends React.Component {
    constructor(props) {
        super();
    }

    render() {
        return (
            <div>
                {/* <ReactToPrint
                    trigger={() => <a href="#">Print this out!</a>}
                    content={() => this.componentRef}
                /> */}
                <ReactToPrint content={() => this.componentRef} documentTitle="Table Calculator">
                    <PrintContextConsumer>
                        {({ handlePrint }) => (
                            <div className="container-export-button-nrw-table">
                                <Tooltip title="Print to PDF and more" placement="right" arrow >
                                    {/* <Button>Arrow</Button> */}
                                    <button className="btn-export-pdf" onClick={handlePrint}><i className="fas fa-print"></i></button>
                                </Tooltip>
                            </div>
                            // <button onClick={handlePrint}>Print this out!</button>
                        )}
                    </PrintContextConsumer>
                </ReactToPrint>
                <hr />
                <TableCalculator
                    data={this.props.data}
                    hasData={this.props.hasData}
                    loadingFillData={this.props.loadingFillData}
                    sendEditValueToParent={this.props.sendEditValueToParent}
                    ref={el => (this.componentRef = el)} />
            </div>
        );
    }
}

// export default TableCalculator
export default ExportPDFCalculateTable
